(async function () {

	const bundle_raw_configuration = JSON.parse($('script#bundle-raw-configuration-json').html()) || {};
	const discount_tiers = {};
	const gift_variants = {};
	const gift_count = {};
	const tier_descriptions = {};

	Object.keys(bundle_raw_configuration?.tiers || {}).forEach(tier => {
		const tierNum = parseInt(tier);
		discount_tiers[tierNum] = parseFloat(bundle_raw_configuration.tiers[tier].discount) || 0;
		gift_variants[tierNum] = bundle_raw_configuration.tiers[tier].gift_variants || [];
		gift_count[tierNum] = parseInt(bundle_raw_configuration.tiers[tier].gift_count) || 0;
		tier_descriptions[tierNum] = bundle_raw_configuration.tiers[tier].description || '';
	});


	// Helper function to get current tier based on quantity
	function getCurrentTier($quantity) {
		$quantity = $quantity || $('.bb-item-active').length;
		const tiers = Object.keys(discount_tiers).sort((a, b) => b - a); // Sort tiers in descending order

		for (const tier of tiers) {
			if ($quantity - (gift_count[tier] || 0) >= parseInt(tier)) {
				return tier;
			}
		}

		return null;
	}

	function getItemText(count) {
		return count === 1 ? 'Item' : 'Items';
	}

	const strings = {
		'update_bundle_in_cart': 'UPDATE BUNDLE IN CART'
	};

	const bundle_metadata = {
		items: {}
	}

	const bundle_key = new URL(window.location.href).searchParams.get('edit');
	let bundle_item;
	if (bundle_key) {
		const cart_data = await (await fetch('/?view=cart_js')).json();
		bundle_item = cart_data.items.find(item => item.key == bundle_key);
		if (bundle_item && Object.keys(bundle_item).length) {

			getStarted()

			setTimeout(function () {
				// Free item first
				for (let item_component of bundle_item.item_components) {
					if ($(`.single-item-holder[data-variant-id="${item_component.id}"]:first .bb-add-to-bundle`).length > 0) {
						for (let i = 0; i < item_component.quantity; i++) {
							$(`.single-item-holder[data-variant-id="${item_component.id}"]:first .bb-add-to-bundle`).click()
						}
					}
				};

				setTimeout(function () {
					for (let item_component of bundle_item.item_components) {
						for (let i = 0; i < item_component.quantity; i++) {
							$(`.single-item-holder[data-variant-id="${item_component.id}"]:first .bb-add-product-bundle`).click()
						}
					};
				}, 1)
			}, 1)
		}
	}

	Shopify.formatMoney = function (cents, format) {
		if (typeof cents === 'string') {
			cents = cents.replace('.', '')
		}
		var value = '';
		var placeholderRegex = /{{\s*(\w+)\s*}}/;
		this.money_format = this.money_format || false;
		var formatString = format || this.money_format;
		var defaultOption = function (opt, def) {
			return (typeof opt === 'undefined' ? def : opt)
		};
		var formatWithDelimiters = function (number, precision, thousands, decimal) {
			precision = defaultOption(precision, 2);
			thousands = defaultOption(thousands, ',');
			decimal = defaultOption(decimal, '.');
			if (isNaN(number) || number == null) {
				return 0
			}
			number = (number / 100.0).toFixed(precision);
			var parts = number.split('.')
				, dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
				, cents = parts[1] ? (decimal + parts[1]) : '';
			return dollars + cents
		};
		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break
		}
		return formatString.replace(placeholderRegex, value)
	};



	function priceUpdate() {

		// Get the current tier based on quantity
		const currentTier = getCurrentTier();
		const hasFreeGift = currentTier && gift_count[currentTier] > 0;

		// Calculate total price of items
		let $price = 0;
		$('.bb-item-active').each(function () {
			const $id = $(this).data('variant-id');
			const $itemPrice = $('.bb-free-bag-item[data-variant-id="' + $id + '"]').data('price');
			$price += $itemPrice;
		});

		// Apply discount based on current tier
		const $priceChange = currentTier ? (1 - (discount_tiers[currentTier] / 100)) : 1;

		// Calculate original and discounted price
		let $originalPrice = $price;
		if (hasFreeGift) {
			const $giftItem = $('.bb-item-active[data-type="gift"]');
			const $giftPrice = $giftItem.length ?
				$('.bb-free-bag-item[data-variant-id="' + $giftItem.data('variant-id') + '"]').data('price') : 19;
			$originalPrice += $giftPrice;
		}

		const $newPrice = $priceChange * $price;

		// Update display
		const $originalPriceFormatted = Shopify.formatMoney($originalPrice, '${{amount}}');
		const $priceFormatted = Shopify.formatMoney($newPrice, '${{amount}}');

		if ($originalPrice > $newPrice) {
			$('.bb-original-price').html($originalPriceFormatted).show();
			const $savings = $originalPrice - $newPrice;
			const $savingsFormatted = Shopify.formatMoney($savings, '${{amount}}');
			$('.bb-savings').html($savingsFormatted).removeClass('hide-savings');
		} else {
			$('.bb-original-price').hide();
			$('.bb-savings').addClass('hide-savings');
		}

		$('.bb-added-items-total p span:not(.bb-original-price)').html($priceFormatted);
		$('.bb-added-items-total').data('price', $newPrice);

	}

	function goToStep($step) {
		$('.bb-steps').hide();
		$('.bb-' + $step).show();
	}

	$(document).on('click', '.bb-next-step[data-target]', function () {
		goToStep($(this).data('target'))
	});

	function addChoiceItem($this) {
		var $target = $this.closest('.bb-free-bag-item'),
			$variantId = $target.data('variant-id'),
			$variantName = $target.data('name'),
			$image = $target.find('.bb-image img').attr('src'),
			$type = $target.data('type'),
			$title = $target.find('h3').text(),
			$price = $target.data('price');
		$('.bb-added-item:first-of-type').html(' ');
		var html = '<a href="javascript:void(0)" class="remove-bb-item-bag"><svg xmlns="http://www.w3.org/2000/svg" width="9.02" height="9.02" viewBox="0 0 9.02 9.02"><g id="Group_2535" data-name="Group 2535" transform="translate(0.354 0.353)"><path id="Path_1691" data-name="Path 1691" d="M-3487.372-4476.921l-8.312-8.313" transform="translate(3495.685 4485.234)" fill="none" stroke="#fff" stroke-width="1"/><path id="Path_1692" data-name="Path 1692" d="M8.312,8.313,0,0" transform="translate(8.313 0) rotate(90)" fill="none" stroke="#fff" stroke-width="1"/></g></svg></a><div class="bb-added-item-image"><img src="' + $image + '" alt="" /></div>';
		$('.bb-added-item:first-of-type').html(html).removeClass('bb-item-placeholder').addClass('bb-item-active').attr('data-variant-id', $variantId).attr('data-name', $variantName).attr('data-image', $image).attr('data-type', $type);

		// Change bag
		if ($this.closest('.bb-collection-tab-item').find('.bb-added-to-bundle').length) {
			var $oldBag = $this.closest('.bb-collection-tab-item').find('.bb-added-to-bundle');
			$oldVariantId = $oldBag.data('variant-id');
			$oldBag.removeClass('bb-added-to-bundle');
			saveToBundleMetadata($oldVariantId, -1);
		}

		priceUpdate();
		saveToBundleMetadata($variantId, 1);
		if (!$('.bb-accordion-container:nth-of-type(2) .bb-accordion-title a').hasClass('accordion-active')) {
			$('.bb-accordion-container:nth-of-type(2) .bb-accordion-title a').trigger('click');
		}

		$('.bb-accordion-disabled').removeClass('bb-accordion-disabled');
		$('.bb-accordion-content:first-of-type .bb-free-bag-item:not(.bb-added-to-bundle) .bb-add-to-bundle').text('Change Bag');

		// Get the lowest tier for initial messaging
		const lowestTier = Object.keys(discount_tiers).sort((a, b) => a - b)[0];

		$('.bb-add-to-cart').text('Select your items');
		$('.bb-progress-text').text(tier_descriptions[lowestTier] || `Add ${lowestTier} more items to get ${discount_tiers[lowestTier]}% Off`); $('.bb-added-items-container').addClass('bb-flexbox');

		var $newBundleProductsCount = parseInt($('#total_bundle_products').val());
		const $countThreshold = parseInt(lowestTier)
		const $callActionCount = $countThreshold - $newBundleProductsCount;
		const $productText = getItemText($callActionCount)
		if ($newBundleProductsCount >= 3) {
			$('.bb-add-to-cart').text('Add Bundle to Cart').addClass('bb-add-to-cart-active');
		} else {
			$('.bb-add-to-cart').text('Add ' + $callActionCount + ' more ' + $productText).removeClass('bb-add-to-cart-active');
		}
	}

	function addNormalItem($this) {
		var $target = $this.closest('.bb-free-bag-item'),
			$variantId = $target.data('variant-id'),
			$variantName = $target.data('name'),
			$image = $target.find('.bb-image img').attr('src'),
			$type = $target.data('type'),
			$title = $target.find('h3').html(),
			$price = $target.data('price');
		const currentQuantityInBundle = getBundleItemQuantity($variantId);
		const maxAllowedQuantity = parseInt($target.data('max'));

		if (maxAllowedQuantity > 0 && currentQuantityInBundle < maxAllowedQuantity) {
			$target.addClass('bb-added-to-bundle');
			$('.bb-added-item.bb-item-active + .bb-item-placeholder').html(' ');
			var html = '<a href="javascript:void(0)" class="remove-bb-item"><svg xmlns="http://www.w3.org/2000/svg" width="9.02" height="9.02" viewBox="0 0 9.02 9.02"><g id="Group_2535" data-name="Group 2535" transform="translate(0.354 0.353)"><path id="Path_1691" data-name="Path 1691" d="M-3487.372-4476.921l-8.312-8.313" transform="translate(3495.685 4485.234)" fill="none" stroke="#fff" stroke-width="1"/><path id="Path_1692" data-name="Path 1692" d="M8.312,8.313,0,0" transform="translate(8.313 0) rotate(90)" fill="none" stroke="#fff" stroke-width="1"/></g></svg></a><div class="bb-added-item-image"><img src="' + $image + '" alt="" /></div>';
			if ($('.bb-added-item.bb-item-active').length) {
				$('.bb-added-item.bb-item-active + .bb-item-placeholder').attr('data-variant-id', $variantId).attr('data-name', $variantName).attr('data-image', $image).attr('data-type', $type).html(html).removeClass('bb-item-placeholder').addClass('bb-item-active');
			} else {
				$('.bb-added-item.bb-item-placeholder:first-of-type').attr('data-variant-id', $variantId).attr('data-name', $variantName).attr('data-image', $image).attr('data-type', $type).html(html).removeClass('bb-item-placeholder').addClass('bb-item-active');
			}
			var $oldTotal = $('.bb-added-items-total').data('price');
			if ($oldTotal == undefined) {
				$newTotal = $oldTotal;
			} else {
				$newTotal = $oldTotal + $price;
			}
			priceUpdate();
			var $oldBundleProductsCount = parseInt($('#total_bundle_products').val());
			$newBundleProductsCount = $oldBundleProductsCount + 1;
			$countThresholdLimit = $newBundleProductsCount;
			$('#total_bundle_products').val($newBundleProductsCount);
			$('.bb-item-active h3 span').remove();

			// Determine the next tier to reach based on current count
			let $nextTier = null;
			let $discount = '';
			const sortedTiers = Object.keys(discount_tiers).sort((a, b) => a - b);

			for (const tier of sortedTiers) {
				if ($newBundleProductsCount < parseInt(tier)) {
					$nextTier = tier;
					$discount = discount_tiers[tier] + '%';
					break;
				}
			}
			// If we've reached the highest tier
			if (!$nextTier) {
				$nextTier = sortedTiers[sortedTiers.length - 1];
				$discount = discount_tiers[$nextTier] + '%';
			}
			$countThreshold = parseInt($nextTier);
			$callActionCount = $countThreshold - $newBundleProductsCount;

			const $productText = getItemText($callActionCount)
			// Update progress text based on tier descriptions
			if ($callActionCount > 0) {
				$callActionText = 'Add ' + $callActionCount + ' more ' + $productText + ' to Get ' + $discount + ' off';
			} else {
				// We've reached or exceeded the highest tier
				const highestTier = sortedTiers[sortedTiers.length - 1];
				$callActionText = 'Congratulations! You get ' + discount_tiers[highestTier] + '% Off';
			}
			$('.bb-progress-text').text($callActionText);
			// Update add to cart button text
			if ($newBundleProductsCount >= parseInt(sortedTiers[0])) {
				if (bundle_key && bundle_item && Object.keys(bundle_item).length) {
					$('.bb-add-to-cart').text(strings.update_bundle_in_cart).addClass('bb-add-to-cart-active');
				} else {
					$('.bb-add-to-cart').text('Add Bundle to Cart').addClass('bb-add-to-cart-active');
				}
			} else {
				$('.bb-add-to-cart').text('Add ' + $callActionCount + ' more ' + $productText);
			}

			// Update placeholder text for remaining slots
			const lowestTier = parseInt(sortedTiers[0]);
			$callActionPlaceCount = lowestTier - $newBundleProductsCount;
			$callActionPlaceCount2 = $callActionPlaceCount + 1;
			$callActionPlaceCount3 = $callActionPlaceCount2 + 1;

			const $productText2 = getItemText($callActionPlaceCount2)
			const $productText3 = getItemText($callActionPlaceCount3)

			var $callActionPlaceholder = 'Add ' + $callActionPlaceCount + ' more ' + $productText + ' & save ' + $discount;
			var $callActionPlaceholder2 = 'Add ' + $callActionPlaceCount2 + ' more ' + $productText2 + ' & save ' + $discount;
			var $callActionPlaceholder3 = 'Add ' + $callActionPlaceCount3 + ' more ' + $productText3 + ' & save ' + $discount;

			$('.bb-item-call-action:not(.bb-item-active) h3').html($callActionPlaceholder);
			$('.bb-item-call-action + .bb-item-call-action:not(.bb-item-active) h3').html($callActionPlaceholder2);
			$('.bb-item-call-action + .bb-item-call-action + .bb-item-call-action:not(.bb-item-active) h3').html($callActionPlaceholder3);

			saveToBundleMetadata($variantId, 1)
		}
	}

	$(document).on('click', '.bb-add-to-bundle', function () {
		addChoiceItem($(this));
	});

	function saveToBundleMetadata(id, quantity = 1) {
		bundle_metadata.items[id] = bundle_metadata.items[id] || { quantity: 0 }
		bundle_metadata.items[id].quantity += quantity;
		let totalItemsInBundle = 0;

		Object.keys(bundle_metadata.items).forEach(function (variant_id) {
			if (bundle_metadata.items[variant_id].quantity > 0) {
				$('.bb-free-bag-item[data-variant-id="' + variant_id + '"]').addClass('bb-added-to-bundle');
				$('.bb-free-bag-item[data-variant-id="' + variant_id + '"] .bb-quantity input').val(bundle_metadata.items[variant_id].quantity)
			} else {
				$('.bb-free-bag-item[data-variant-id="' + variant_id + '"]').removeClass('bb-added-to-bundle');
				$('.bb-free-bag-item[data-variant-id="' + variant_id + '"] .bb-quantity input').val(1)
			}
			const maxQuantity = parseInt($('.bb-free-bag-item[data-variant-id="' + variant_id + '"]').data('max'))
			if (maxQuantity > 0) {
				if (bundle_metadata.items[variant_id].quantity >= maxQuantity) {
					$('.bb-free-bag-item[data-variant-id="' + variant_id + '"] .bb-add-product-bundle').addClass('disabled').attr('disabled', true)
				} else {
					$('.bb-free-bag-item[data-variant-id="' + variant_id + '"] .bb-add-product-bundle').removeClass('disabled').removeAttr('disabled')
				}
			}

			totalItemsInBundle += bundle_metadata.items[variant_id].quantity
		})
		// Get the highest tier
		const highestTier = Object.keys(discount_tiers).sort((a, b) => b - a)[0];
		const hasFreeGift = gift_count[highestTier] > 0;

		// Determine the maximum items allowed in the bundle
		const maxItems = hasFreeGift ? parseInt(highestTier) + 1 : parseInt(highestTier);

		if (totalItemsInBundle >= maxItems) {
			$('.bb-add-product-bundle').addClass('disabled').attr('disabled', 'disabled');
		} else {
			$('.bb-add-product-bundle').removeClass('disabled').removeAttr('disabled');
		}
	}

	function getBundleItemQuantity(id) {
		bundle_metadata.items[id] = bundle_metadata.items[id] || { quantity: 0 }
		return bundle_metadata.items[id].quantity
	}

	$(document).on('click', '.bb-add-product-bundle', function () {
		addNormalItem($(this))
	});

	$(document).on('click', '.cancel-upsell', function () {
		$('.upsell-popup').fadeOut();
		addToCart();
	});

	$(document).on('click', '.bb-add-to-cart-active', function () {
		if ($('.upsell-popup').length) {
			var count = $('#total_bundle_products').val();
			var $title = $('.upsell-popup-content h2').data('title');
			var $variant = $('.upsell-popup').data('variant-id');

			// Get the tiers that would apply with one more item
			const nextTierCount = parseInt(count) + 1;
			const tiers = Object.keys(discount_tiers).sort((a, b) => a - b);
			let nextTier = null;

			for (const tier of tiers) {
				if (nextTierCount >= parseInt(tier) && parseInt(tier) > parseInt(count)) {
					nextTier = tier;
					break;
				}
			}

			if ($('.bb-added-item[data-variant-id="' + $variant + '"]').length || count >= parseInt(tiers[tiers.length - 1])) {
				addToCart();
			} else {
				if (nextTier) {
					var $text = 'Add ' + $title + ' to your bundle and save ' + discount_tiers[nextTier] + '%';
					$('.upsell-popup-content h2').html($text);
					$('.upsell-popup').fadeIn();
				} else {
					addToCart();
				}
			}
		} else {
			addToCart();
		}
	});

	$(document).on('click', '.add-upsell', function () {
		var $this = $(this),
			$target = $this.closest('.upsell-popup'),
			$variantId = $target.data('variant-id'),
			$variantName = $target.data('name'),
			$image = $target.find('.upsell-popup-content img').attr('src'),
			$type = $target.data('type'),
			$title = $target.find('h2').data('title'),
			$price = $target.data('price');
		$('.bb-added-item.bb-item-active + .bb-item-placeholder').html(' ');
		var html = '<a href="javascript:void(0)" class="remove-bb-item"><svg xmlns="http://www.w3.org/2000/svg" width="9.02" height="9.02" viewBox="0 0 9.02 9.02"><g id="Group_2535" data-name="Group 2535" transform="translate(0.354 0.353)"><path id="Path_1691" data-name="Path 1691" d="M-3487.372-4476.921l-8.312-8.313" transform="translate(3495.685 4485.234)" fill="none" stroke="#fff" stroke-width="1"/><path id="Path_1692" data-name="Path 1692" d="M8.312,8.313,0,0" transform="translate(8.313 0) rotate(90)" fill="none" stroke="#fff" stroke-width="1"/></g></svg></a><div class="bb-added-item-image"><img src="' + $image + '" alt="" /></div>';
		$('.bb-added-item.bb-item-active + .bb-item-placeholder').attr('data-variant-id', $variantId).attr('data-name', $variantName).attr('data-image', $image).attr('data-type', $type).html(html).removeClass('bb-item-placeholder').addClass('bb-item-active');
		var $oldTotal = $('.bb-added-items-total').data('price');
		$newTotal = $oldTotal + $price;
		priceUpdate();
		var $oldBundleProductsCount = parseInt($('#total_bundle_products').val());
		$newBundleProductsCount = $oldBundleProductsCount + 1;
		$countThresholdLimit = $newBundleProductsCount;
		$('#total_bundle_products').val($newBundleProductsCount);
		$('.bb-item-active h3 span').remove();
		// Determine the next tier to reach based on current count
		let $nextTier = null;
		let $discount = '';
		const sortedTiers = Object.keys(discount_tiers).sort((a, b) => a - b);

		for (const tier of sortedTiers) {
			if ($newBundleProductsCount < parseInt(tier)) {
				$nextTier = tier;
				$discount = discount_tiers[tier] + '%';
				break;
			}
		}

		// If we've reached the highest tier
		if (!$nextTier) {
			$nextTier = sortedTiers[sortedTiers.length - 1];
			$discount = discount_tiers[$nextTier] + '%';
		}

		$countThreshold = parseInt($nextTier);
		$callActionCount = $countThreshold - $newBundleProductsCount;

		const $productText = getItemText($callActionCount)
		$callActionText = 'Add ' + $callActionCount + ' more ' + $productText + ' to Get ' + $discount + ' off';
		// Update progress text based on tier descriptions
		if ($callActionCount > 0) {
			$callActionText = 'Add ' + $callActionCount + ' more ' + $productText + ' to Get ' + $discount + ' off';
		} else {
			// We've reached or exceeded the highest tier
			const highestTier = sortedTiers[sortedTiers.length - 1];
			$callActionText = 'Congratulations! You get ' + discount_tiers[highestTier] + '% Off';
		}
		$('.bb-progress-text').text($callActionText);

		// Update add to cart button text
		if ($newBundleProductsCount >= parseInt(sortedTiers[0])) {
			$('.bb-add-to-cart').text('Add Bundle to Cart').addClass('bb-add-to-cart-active');
		} else {
			$('.bb-add-to-cart').text('Add ' + $callActionCount + ' more ' + $productText);
		}// Update placeholder text for remaining slots
		const lowestTier = parseInt(sortedTiers[0]);
		$callActionPlaceCount = lowestTier - $newBundleProductsCount;
		$callActionPlaceCount2 = $callActionPlaceCount + 1;
		$callActionPlaceCount3 = $callActionPlaceCount2 + 1;

		const $productText2 = getItemText($callActionPlaceCount2)
		const $productText3 = getItemText($callActionPlaceCount3)

		var $callActionPlaceholder = 'Add ' + $callActionPlaceCount + ' more ' + $productText + ' & save ' + $discount;
		var $callActionPlaceholder2 = 'Add ' + $callActionPlaceCount2 + ' more ' + $productText2 + ' & save ' + $discount;
		var $callActionPlaceholder3 = 'Add ' + $callActionPlaceCount3 + ' more ' + $productText3 + ' & save ' + $discount;

		$('.bb-item-call-action:not(.bb-item-active) h3').html($callActionPlaceholder);
		$('.bb-item-call-action + .bb-item-call-action:not(.bb-item-active) h3').html($callActionPlaceholder2);
		$('.bb-item-call-action + .bb-item-call-action + .bb-item-call-action:not(.bb-item-active) h3').html($callActionPlaceholder3);
		$('.upsell-popup').fadeOut();
		saveToBundleMetadata($variantId, 1)
		addToCart();
	});

	function resetBundle() {
		document.querySelector('.bb-added-items-content').innerHTML = document.querySelector('#bb-added-items-template').innerHTML;
		document.querySelectorAll('.bb-free-bag-item').forEach(elem => elem.classList.remove('bb-added-to-bundle'));

		document.querySelectorAll('.bb-free-bag-item').forEach(elem => {
			elem.classList.remove('bb-added-to-bundle')
			elem.querySelector('.bb-add-product-bundle')?.classList.remove('disabled');
		});

		const current_url = new URL(window.location.href);
		current_url.searchParams.delete('edit');
		window.history.replaceState(null, '', current_url);
		bundle_item = null;


		Object.keys(bundle_metadata.items).forEach(itemId => {
			const currentQuantity = getBundleItemQuantity(itemId);
			if (currentQuantity) {
				saveToBundleMetadata(itemId, -currentQuantity)
			}
		});

		$('#total_bundle_products').val(0)
		$('.bb-accordion-container:not(:first-of-type)').addClass('bb-accordion-disabled');
	}

	function addToCart() {
		const _timestamp = new Date().getTime();
		var $data = [];

		// Determine if free gift is applicable based on current tier
		const currentTier = getCurrentTier();
		const hasFreeGift = currentTier && gift_count[currentTier] > 0;

		// Count products excluding free gifts
		if (hasFreeGift) {
			var productsInBundle = -1; // Deduct one for the free gift
		} else {
			var productsInBundle = 0;
		}

		const parentProductJson = JSON.parse($('script#parent-product-json').html());
		let childIds = [];
		let childProductNames = [];

		$('.bb-item-active').each(function () {
			var $this = $(this);
			const $variant = $this.data('variant-id');
			const $name = $this.data('name') + '|' + $this.data('type') + '||' + $this.data('image');
			$data.push({
				'quantity': 1,
				'id': $variant,
				properties: {
					_bundle_product: 'Yes',
					_unique_bundle_id: _timestamp,
				}
			});

			childIds.push($variant);
			childProductNames.push($name);
			productsInBundle++;
		});

		// Find the variant of parent product that suites for number of productsInBundle
		const parentVariant = parentProductJson.variants.find(variant => productsInBundle === parseInt(variant.title.split('-')[0]))
		$data.push({
			'quantity': 1,
			'id': parentVariant.id,
			properties: {
				_bundle_product: 'Yes',
				_unique_bundle_id: _timestamp,
			}
		});

		const cart_holder = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
		const sections = cart_holder.getSectionsToRender().map((section) => section.id);
		cart_holder.setActiveElement(document.getElementById('CartDrawer'));
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			dataType: 'json',
			data: {
				items: $data,
				sections,
				sections_url: window.location.pathname + (window.location.search || '')
			},
			success: function (response) {
				if (response.status) {
					alert(response.description || 'An error has occurred.')
					return;
				}

				let cartAddResponse = response;
				if (bundle_key && bundle_item && Object.keys(bundle_item).length) {
					let updates = {};
					updates[bundle_key] = 0;

					fetch(window.Shopify.routes.root + 'cart/update.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							updates, sections,
							sections_url: window.location.pathname + (window.location.search || '')
						})
					}).then(response => {
						return response.json();
					}).then(response => {
						if (cart_holder && cart_holder.classList.contains('is-empty')) {
							cart_holder.classList.remove('is-empty');
						}
						cart_holder.renderContents(response);
					})
						.catch((error) => {
							console.error('Error:', error);
						});
				} else {
					if (cart_holder && cart_holder.classList.contains('is-empty')) {
						cart_holder.classList.remove('is-empty');
					}
					cart_holder.renderContents(response);
				}
			},
			error: function (response, a, b) {
				if (response) {
					alert(response?.responseJSON?.description || 'An error has occurred.')
					return;
				}
			},
			complete: function (data) {
				resetBundle();
			}
		});
	}

	$(document).on('click', '.bb-collection-tab-nav a', function () {
		var $this = $(this),
			$target = $($this.attr('href')),
			$parent = $this.closest('li');
		if (!$parent.hasClass('.bb-active-tab')) {
			$('.bb-collection-tab-nav li').removeClass('bb-active-tab');
			$parent.addClass('bb-active-tab');
			$('.bb-collection-tab-item').hide();
			$target.show();
			return false;
		}
	});
	$(document).on('click', '.remove-bb-item', function () {
		var $this = $(this),
			$target = $this.closest('.bb-item-active'),
			$variantId = $target.data('variant-id'),
			$insertPoint = $('.bb-item-active + .bb-item-placeholder'),
			$count = $('.bb-item-active').length;
		// Get tier information for display
		const tiers = Object.keys(discount_tiers).sort((a, b) => parseInt(a) - parseInt(b));

		// Determine correct placeholder based on configuration
		var $html;

		// Check if free gift is applicable
		const hasFreeGift = gift_count[tiers[tiers.length - 1]] > 0;

		// Check if free gift has been removed before other products. If it has then count must remain the same
		if($count > 0 && $('.bb-added-item:first-of-type').hasClass('bb-item-placeholder')) {
			$count = $count + 1;
		}
		if (hasFreeGift) {
			if ($count == parseInt(tiers[tiers.length - 1]) + 1) {
				$html = '<div class="bb-added-item bb-item-placeholder bb-item-call-action"><div class="bb-added-item-image"><span>' + discount_tiers[tiers[tiers.length - 1]] + '% Off</span></div></div>';
			} else if ($count == parseInt(tiers[tiers.length - 2]) + 1) {
				$html = '<div class="bb-added-item bb-item-placeholder bb-item-call-action"><div class="bb-added-item-image"><span>' + discount_tiers[tiers[tiers.length - 2]] + '% Off</span></div></div>';
			} else if ($count == parseInt(tiers[0]) + 1) {
				$html = '<div class="bb-added-item bb-item-placeholder bb-item-call-action"><div class="bb-added-item-image"><span>' + discount_tiers[tiers[0]] + '% Off</span></div></div>';
			} else {
				$html = '<div class="bb-added-item bb-item-placeholder"><div class="bb-added-item-image"></div></div>';
			}
		} else {
			if ($count == parseInt(tiers[tiers.length - 1])) {
				$html = '<div class="bb-added-item bb-item-placeholder bb-item-call-action"><div class="bb-added-item-image"><span>' + discount_tiers[tiers[tiers.length - 1]] + '% Off</span></div></div>';
			} else if ($count == parseInt(tiers[tiers.length - 2])) {
				$html = '<div class="bb-added-item bb-item-placeholder bb-item-call-action"><div class="bb-added-item-image"><span>' + discount_tiers[tiers[tiers.length - 2]] + '% Off</span></div></div>';
			} else if ($count == parseInt(tiers[0])) {
				$html = '<div class="bb-added-item bb-item-placeholder bb-item-call-action"><div class="bb-added-item-image"><span>' + discount_tiers[tiers[0]] + '% Off</span></div></div>';
			} else {
				$html = '<div class="bb-added-item bb-item-placeholder"><div class="bb-added-item-image"></div></div>';
			}
		}
		if ($insertPoint.length) {
			$insertPoint.before($html);
		} else {
			$('.bb-added-items-container').append($html);
		}
		$target.remove();

		var $oldBundleProductsCount = parseInt($('#total_bundle_products').val());
		$newBundleProductsCount = $oldBundleProductsCount - 1;
		$('#total_bundle_products').val($newBundleProductsCount);

		// Determine the next tier to reach based on current count
		let $nextTier = null;
		let $discount = '';
		const sortedTiers = Object.keys(discount_tiers).sort((a, b) => a - b);

		for (const tier of sortedTiers) {
			if ($newBundleProductsCount < parseInt(tier)) {
				$nextTier = tier;
				$discount = discount_tiers[tier] + '%';
				break;
			}
		}

		// If we've reached the highest tier
		if (!$nextTier) {
			$nextTier = sortedTiers[sortedTiers.length - 1];
			$discount = discount_tiers[$nextTier] + '%';
		}

		$countThreshold = parseInt($nextTier);
		$callActionCount = $countThreshold - $newBundleProductsCount;


		const $productText = getItemText($callActionCount)

		// Update progress text based on tier descriptions
		if ($callActionCount > 0) {
			$callActionText = tier_descriptions[$nextTier] ? tier_descriptions[$nextTier] : 'Add ' + $callActionCount + ' more ' + $productText + ' to Get ' + $discount + ' off';
		} else {
			// We've reached or exceeded the highest tier
			const highestTier = sortedTiers[sortedTiers.length - 1];
			$callActionText = 'Congratulations! You get ' + discount_tiers[highestTier] + '% Off';
		}

		$('.bb-progress-text').text($callActionText);

		// Update add to cart button text
		if ($newBundleProductsCount >= parseInt(sortedTiers[0])) {
			if (bundle_key && bundle_item && Object.keys(bundle_item).length) {
				$('.bb-add-to-cart').text(strings.update_bundle_in_cart).addClass('bb-add-to-cart-active');
			} else {
				$('.bb-add-to-cart').text('Add Bundle to Cart').addClass('bb-add-to-cart-active');
			}
		} else {
			$('.bb-add-to-cart').text('Add ' + $callActionCount + ' more ' + $productText).removeClass('bb-add-to-cart-active');
		}
		var $quantity = parseInt($('.bb-free-bag-item[data-variant-id="' + $variantId + '"] .bb-quantity input').val());
		if ($quantity > 1) {
			$quantity = parseInt($quantity) - 1;
			$('.bb-free-bag-item[data-variant-id="' + $variantId + '"] .bb-quantity input').val($quantity);
		} else {
			$('.bb-free-bag-item[data-variant-id="' + $variantId + '"]').removeClass('bb-added-to-bundle');
		}

		priceUpdate();
		saveToBundleMetadata($variantId, -1);
	});

	$(document).on('click', '.remove-bb-item-bag', function () {
		var $this = $(this),
			$target = $this.closest('.bb-item-active'),
			$variantId = $target.data('variant-id'),
			$insertPoint = $target,
			$count = $('.bb-item-active').length;
		$html = '<div class="bb-added-item bb-item-placeholder"><div class="bb-added-item-image"></div><h3></h3></div>'
		if ($insertPoint.length) {
			$insertPoint.before($html);
		} else {
			$('.bb-added-items-container').append($html);
		}
		$target.remove();
		$('.bb-add-to-cart').text('Add your free bag').removeClass('bb-add-to-cart-active');
		$('.bb-added-items-container').removeClass('bb-flexbox');
		$('.bb-progress-text').text('Choose your free bag');
		if ($count == 1) {
			// open free bag accordion
		}
		$('.bb-free-bag-item[data-variant-id="' + $variantId + '"]').removeClass('bb-added-to-bundle');
		priceUpdate();
		saveToBundleMetadata($variantId, -1);
		$('.bb-accordion-container:not(:first-of-type)').addClass('bb-accordion-disabled');
		if (!$('.bb-accordion-container:first-of-type .bb-accordion-title a').hasClass('accordion-active')) {
			$('.bb-accordion-container:first-of-type .bb-accordion-title a').trigger('click');
		}
		$('.bb-accordion-content:first-of-type .bb-free-bag-item .bb-add-to-bundle').text('Add to Bundle');
	});

	$(document).on('click', '.bb-product-details', function () {
		var $this = $(this),
			$url = '/products/' + $this.attr('href'),
			$type = $this.data('type'),
			$weight = $this.data('weight'),
			$desc = $this.data('desc'),
            $variantid = $this.data('variant-id'),
            $variantPrice = $this.data('price'),
            $variantImage = $this.data('image'),
            $productImage = $this.data('product-image'),
            $productName = $this.data('product-name');
		$('.bb-mobile-content img').attr('src', '');
		$('.bb-mobile-content img + img').attr('src', '');
		$('.bb-mobile-content .rte').html('');
		$('.bb-product-type .rte').html('');
		$('.bb-mobile-content .bb-add-bundle-trigger').attr('data-variant-id', '');
		$('.bb-product-title').html('');
		$('.bb-price').html('');
		$.ajax({
			type: 'GET',
			url: $url,
			dataType: 'json',
			success: function (data) {
				var product = data.product,
					$image = $variantImage || product.image.src,
					$image2 = $productImage || product.images[1].src,
					$variant_id = $variantid || product.variants[0].id,
					$price = $variantPrice || '$'+product.variants[0].price,
					$title = $productName || product.title;
				$('.bb-product-title').html($title);
				$('.bb-mobile-content img').attr('src', $image);
				$('.bb-product-type').html($type);
				$('.bb-mobile-content img + img').attr('src', $image2);
				$('.bb-mobile-content .rte').html($desc);
				$('.bb-mobile-content .bb-add-bundle-trigger').attr('data-variant-id', $variant_id);
				if ($weight == '' | $weight == ' ') {
					$('.bb-price').html('<strong>' + $price + '</strong>');
				} else {
					$('.bb-price').html('<strong>' + $price + '</strong> | ' + $weight);
				}
			}
		});
		return false;
	});

	$(document).on('click', '.bb-add-bundle-trigger', function () {
		var $this = $(this),
			$variant = $this.attr('data-variant-id');
		$('.bb-collection-tab-item:visible .bb-free-bag-item[data-variant-id="' + $variant + '"] .bb-add-product-bundle').trigger('click');
		$('.bb-show-popup').removeClass('bb-show-popup');
	});

	$(document).on('click', '.bb-quantity .bb-quantity-minus', function () {
		var $this = $(this),
			$quantityInput = $this.closest('.bb-quantity').find('input'),
			$min = $quantityInput.attr('min'),
			$quantity = $quantityInput.val();
		var $variantId = $this.closest('.bb-free-bag-item').attr('data-variant-id');
		$('.bb-added-item[data-variant-id="' + $variantId + '"]').each(function (index) {
			var $this = $(this);
			if (index == 0) {
				$this.find('.remove-bb-item').trigger('click');
			}
		});
	});

	$(document).on('click', '.bb-quantity .bb-quantity-plus', function () {
		var $this = $(this),
			$quantityInput = $this.closest('.bb-quantity').find('input'),
			$max = parseInt($quantityInput.attr('max')),
			$quantity = parseInt($quantityInput.val());
		if ($quantity < $max && getBundleItemQuantity(parseInt($this.closest('[data-variant-id]').data('variant-id'))) < $max) {
			$quantity = parseInt($quantity) + 1;
			$quantityInput.val($quantity).trigger('change');
			$this.closest('.bb-free-bag-item').find('.bb-add-product-bundle').trigger('click');
		}
	});

	$(document).on('change input', '.bb-quantity input', function () {

		var $this = $(this),
			$min = parseInt($this.attr('min')),
			$max = parseInt($this.attr('max')),
			$quantity = parseInt($this.val());

		if ($quantity < $min && getBundleItemQuantity(parseInt($this.closest('[data-variant-id]').data('variant-id'))) < $max) {
			$this.val($min);
		} else if ($quantity > $max) {
			$this.val($max);
		}

	});
	$(document).on('click', '.bb-accordion-title a', function () {
		var $this = $(this),
			$target = $this.closest('.bb-accordion-container').find('.bb-accordion-content');
		if (!$target.is(':visible')) {
			$('.bb-accordion-content:visible').slideUp();
			$('.accordion-active').removeClass('accordion-active');
			$this.addClass('accordion-active');
			$target.slideDown(function () {
				$offset = $this.offset().top;
				$('html, body').animate({
					'scrollTop': $offset
				})
			});
		} else {
			$this.removeClass('accordion-active');
			$target.slideUp();
		}
	});

	function getStarted() {
		var $offset = $('.bb-collection-container').offset().top;
		$('html, body').animate({
			'scrollTop': $offset
		});
	}

	$(document).on('click', '.get-started-btn', function () {
		getStarted();
		return false;
	});
})()